import { Injectable } from "@angular/core";
import { APP_SETTINGS } from "../../shared/models/backofficeConfiguration";
import { ExecuteService } from "../../shared/services/executeService.service";
import { ErrorHandlerService } from "../../shared/services/errorHandler.service";
import { map, catchError } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { CacheService } from "../../shared/services/cache.service";
import { Country } from "../model/Country";

@Injectable()
export class CountryService {
    private masterDataApiURL = APP_SETTINGS.MasterDataApiUrl;

    constructor(private cacheService: CacheService,
        private executeService: ExecuteService,
        private errorHandler: ErrorHandlerService) { }

    public GetCountries(): Observable<Country[]> {
        const url = `${this.masterDataApiURL}countryManager`;
        
        return this.cacheService.get('getCountries', this.executeService.ExecuteWithToken('get', url)
            .pipe(
                map(response => this.mapCountryModels(response.Countries)),
                catchError(this.errorHandler.handleError<object[]>('CountryService_GetCountries', []))
        ));
    }

    private mapCountryModels(countries: any[]): Country[] {
        let response: Country[] = [];
        if (response != null) {
            response = countries.map(c => ({
                code: c.Code,
                name: c.Name
            }));
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/app/brokers/services/country.service.ts